module.exports = __webpack_public_path__ + "img/dku.01992.c9991868.png";